unit unit_Provisionsabrechnungen;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, strutils, XData.Web.Client, DB;

type
  TProvisionsabrechnungen = class(TForm)
    xdsPAbrechnung: TXDataWebDataSet;
    TC: TTableControl;
    WClient: TXDataWebClient;
    xdsPAbrechnungNummerkomplett: TStringField;
    xdsPAbrechnungJahr: TFloatField;
    xdsPAbrechnungAuftragsbezeichnung: TStringField;
    xdsPAbrechnungDatum: TDateTimeField;
    xdsPAbrechnungBruttosumme: TFloatField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsPAbrechnungAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    Belegnummer:string;
    mybuttonDetails:TButton;
    buttonzurueck:TButton;
    procedure buttonzurueckclick(Sender:TObject);
    procedure mybuttonDetailsclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Provisionsabrechnungen: TProvisionsabrechnungen;

implementation
  uses unit1, unit2, unit_EinzelBeleg;
{$R *.dfm}
procedure TProvisionsabrechnungen.mybuttonDetailsclick(Sender:TObject);
var
  EinzelBeleg:TEinzelBeleg;
    procedure AfterCreate(AForm:TObject);
    begin
      with sender as TButton do
      begin
        Belegnummer:=tc.Cells[0,tag];
        Belegnummer:=replacestr(Belegnummer,'<b>','');
        Belegnummer:=replacestr(Belegnummer,'</b>','');
      end;
      (AForm as TEinzelBeleg).Belegnummer:=Belegnummer;
      (AForm as TEinzelBeleg).Belegart:='EingangsRechnungen';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //nothing to do
    end;

  begin

  EinzelBeleg:=TEinzelBeleg.CreateNew(@AfterCreate);
  EinzelBeleg.ShowModal(@AfterShowmodal);

end;
procedure TProvisionsabrechnungen.buttonzurueckclick(Sender:TObject);
begin
  close;
end;



procedure TProvisionsabrechnungen.WebFormShow(Sender: TObject);
begin
  xdsPAbrechnung.Close;
  xdsPAbrechnung.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$orderby=Nummerkomplett DESC' ;
  xdsPAbrechnung.Load;
end;

procedure TProvisionsabrechnungen.xdsPAbrechnungAfterOpen(DataSet: TDataSet);
var
  temptext:string;
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=5;
  tc.RowCount:=xdsPAbrechnung.RecordCount+3;
  TC.Cells[0,0]:='<h4>Provisionsabrechnungen';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  tc.Cells[0,i]:='<b>Abrechnung-Nr.';
  tc.Cells[1,i]:='<b>Datum';
  tc.Cells[2,i]:='<b>Bezeichnung';
  tc.Cells[3,i]:='<b>Betrag';
  tc.Cells[4,i]:='<b>Download';
  xdsPAbrechnung.First;
  while not xdsPAbrechnung.eof do
  begin
    inc(i);
    tc.Cells[0,i]:='<b>'+xdsPAbrechnungNummerkomplett.AsString+'</b>';
    tc.Cells[1,i]:=formatdatetime('DD.MM.YYYY',xdsPAbrechnungDatum.Asdatetime);
    tc.Cells[2,i]:=xdsPAbrechnungAuftragsbezeichnung.AsString;
    tc.Cells[3,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPAbrechnungBruttosumme.Asfloat);

    myelement:=TC.cellelements[4,i];
    mybuttonDetails:=TButton.Create(self);
    mybuttonDetails.ElementClassName:='btn btn-info text-left';
    mybuttonDetails.HeightStyle:=ssauto;
    mybuttonDetails.WidthStyle:=ssauto;
    mybuttonDetails.tag:=i;
    mybuttonDetails.Caption:='Details';
    mybuttonDetails.OnClick:=@mybuttonDetailsclick;
    mybuttonDetails.ParentElement:=myelement;
    xdsPAbrechnung.Next;
  end;

end;

procedure TProvisionsabrechnungen.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsPAbrechnung := TXDataWebDataSet.Create(Self);
  xdsPAbrechnungNummerkomplett := TStringField.Create(Self);
  xdsPAbrechnungJahr := TFloatField.Create(Self);
  xdsPAbrechnungAuftragsbezeichnung := TStringField.Create(Self);
  xdsPAbrechnungDatum := TDateTimeField.Create(Self);
  xdsPAbrechnungBruttosumme := TFloatField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsPAbrechnung.BeforeLoadDFMValues;
  xdsPAbrechnungNummerkomplett.BeforeLoadDFMValues;
  xdsPAbrechnungJahr.BeforeLoadDFMValues;
  xdsPAbrechnungAuftragsbezeichnung.BeforeLoadDFMValues;
  xdsPAbrechnungDatum.BeforeLoadDFMValues;
  xdsPAbrechnungBruttosumme.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'Provisionsabrechnungen';
    Width := 216;
    Height := 413;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 216;
    TC.Height := 413;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.Align := alClient;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.Options.ScrollVertical := True;
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsPAbrechnung.SetParentComponent(Self);
    xdsPAbrechnung.Name := 'xdsPAbrechnung';
    xdsPAbrechnung.AfterOpen := xdsPAbrechnungAfterOpen;
    xdsPAbrechnung.EntitySetName := 'EingangsRE';
    xdsPAbrechnung.Connection := DM2.XDataWebConnection1;
    xdsPAbrechnung.Left := 16;
    xdsPAbrechnung.Top := 288;
    xdsPAbrechnungNummerkomplett.SetParentComponent(xdsPAbrechnung);
    xdsPAbrechnungNummerkomplett.Name := 'xdsPAbrechnungNummerkomplett';
    xdsPAbrechnungNummerkomplett.FieldName := 'Nummerkomplett';
    xdsPAbrechnungNummerkomplett.Required := True;
    xdsPAbrechnungNummerkomplett.Size := 10;
    xdsPAbrechnungJahr.SetParentComponent(xdsPAbrechnung);
    xdsPAbrechnungJahr.Name := 'xdsPAbrechnungJahr';
    xdsPAbrechnungJahr.FieldName := 'Jahr';
    xdsPAbrechnungAuftragsbezeichnung.SetParentComponent(xdsPAbrechnung);
    xdsPAbrechnungAuftragsbezeichnung.Name := 'xdsPAbrechnungAuftragsbezeichnung';
    xdsPAbrechnungAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    xdsPAbrechnungAuftragsbezeichnung.Size := 255;
    xdsPAbrechnungDatum.SetParentComponent(xdsPAbrechnung);
    xdsPAbrechnungDatum.Name := 'xdsPAbrechnungDatum';
    xdsPAbrechnungDatum.FieldName := 'Datum';
    xdsPAbrechnungDatum.Required := True;
    xdsPAbrechnungBruttosumme.SetParentComponent(xdsPAbrechnung);
    xdsPAbrechnungBruttosumme.Name := 'xdsPAbrechnungBruttosumme';
    xdsPAbrechnungBruttosumme.FieldName := 'Bruttosumme';
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 112;
    WClient.Top := 296;
  finally
    TC.AfterLoadDFMValues;
    xdsPAbrechnung.AfterLoadDFMValues;
    xdsPAbrechnungNummerkomplett.AfterLoadDFMValues;
    xdsPAbrechnungJahr.AfterLoadDFMValues;
    xdsPAbrechnungAuftragsbezeichnung.AfterLoadDFMValues;
    xdsPAbrechnungDatum.AfterLoadDFMValues;
    xdsPAbrechnungBruttosumme.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.
